import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { User } from 'src/app/model/User';
import { NewcontractService } from 'src/app/services/contracts/newcontract.service';
import { LoaderService } from 'src/app/services/loader.service';
const moment = _moment;
@Component({
  selector: 'app-newcontract',
  templateUrl: './newcontract.component.html',
  styleUrls: ['./newcontract.component.css'],
})
export class NewcontractComponent implements OnInit {
  templates = [
    {
      entity: 'nishtech',
      template: ['NISH-Evere', 'NISH-Kraainem'],
    },
    {
      entity: 'nish',
      template: ['NISH Technologies-Evere', 'NISH Technologies-Sterrebeek'],
    },
  ];

  filteredTemplates: any = [];
  selectedEntity: string;
  nishContractId: number;
  successFlag: Boolean = false;
  errorFlag: Boolean = false;
  errorDescription: any;
  empName: any;
  customerName: any;
  contract: any;
  filterEmpName: string;
  filterCustomerName: string;
  user: User;
  loading$: any;
  showOverTimeSection: boolean = false;

  newContractForm: FormGroup = new FormGroup({});

  get isSearchDisabled(): boolean {
    return !!this.newContractForm.get('searchNishContractId')?.value;
  }

  get isCloneDisabled(): boolean {
    return !!this.newContractForm.get('nishContractId')?.value;
  }

  constructor(
    private fb: FormBuilder,
    private newcontractService: NewcontractService,
    public loader: LoaderService,
  ) {}

  ngOnInit(): void {
    this.newContractForm = this.fb.group({
      nishContractId: [''],
      searchNishContractId: [''],
      employeeId: [''],
      contractId: [''],
      contractStatus: ['', Validators.required],
      clientName: ['', Validators.required],
      contractCompanyName: ['', Validators.required],
      subContractCompany1: [''],
      subContractCompany2: [''],
      subContractCompany3: [''],
      billingRate: ['', Validators.required],
      contractStartDate: ['', Validators.required],
      contractEndDate: ['', Validators.required],
      contractType: ['', Validators.required],
      perDayHrs: ['', Validators.required],
      comments: [''],
      updatedBy: [''],
      contractReference: [''],
      vosReference: [''],
      entity: ['', Validators.required],
      template: ['', Validators.required],
      tsFlag: ['', Validators.required],
      invoicesDH: ['', Validators.required],
      invoiceDueDate: [''],
      billingDays: ['', Validators.required],
      customerId: [''],
      isOverTime: [],
      contractOverTime: this.fb.group({
        otWeekEnds: [0, !Validators.required],
        otWeekEndsDH: ['H', !Validators.required],
        otSaturdays: [0, !Validators.required],
        otSaturdaysDH: ['H', !Validators.required],
        otSundayPH: [0],
        otSundayPHDH: ['H', !Validators.required],
        onCallWK: [0, !Validators.required],
        onCallWKDH: ['D', !Validators.required],
        onCallSaturday: [0, !Validators.required],
        onCallSaturdayDH: ['D', !Validators.required],
        onCallSunPH: [0, !Validators.required],
        onCallSunPHDH: ['D', !Validators.required],
        others: [0, !Validators.required],
        othersPHDH: ['D', !Validators.required],
        othersDesc: ['', !Validators.required],
      }),
    });

    // When user types in Search NISH Contract ID, clear and disable Clone field
    const searchCtrl = this.newContractForm.get('nishContractId');
    const cloneCtrl = this.newContractForm.get('searchNishContractId');
    let isClearing = false;

    if (searchCtrl && cloneCtrl) {
      const clearContractFields = () => {
        if (isClearing) return; // Prevent recursive clearing
        isClearing = true;

        try {
          this.contract = null;
          this.empName = null;
          this.customerName = null;
          this.filterEmpName = '';
          this.filterCustomerName = '';
          this.showOverTimeSection = false;

          // Patch all fields individually with emitEvent: false to avoid cascading valueChanges
          this.newContractForm.patchValue(
            {
              employeeId: '',
              contractId: '',
              contractStatus: '',
              clientName: '',
              contractCompanyName: '',
              subContractCompany1: '',
              subContractCompany2: '',
              subContractCompany3: '',
              billingRate: '',
              contractStartDate: '',
              contractEndDate: '',
              contractType: '',
              perDayHrs: '',
              comments: '',
              updatedBy: '',
              contractReference: '',
              vosReference: '',
              entity: '',
              template: '',
              tsFlag: '',
              invoicesDH: '',
              invoiceDueDate: '',
              billingDays: '',
              customerId: '',
              isOverTime: false,
            },
            { emitEvent: false },
          );

          this.newContractForm.get('contractOverTime')?.patchValue(
            {
              otWeekEnds: 0,
              otWeekEndsDH: 'H',
              otSaturdays: 0,
              otSaturdaysDH: 'H',
              otSundayPH: 0,
              otSundayPHDH: 'H',
              onCallWK: 0,
              onCallWKDH: 'D',
              onCallSaturday: 0,
              onCallSaturdayDH: 'D',
              onCallSunPH: 0,
              onCallSunPHDH: 'D',
              others: 0,
              othersPHDH: 'D',
              othersDesc: '',
            },
            { emitEvent: false },
          );

          this.newContractForm.get('employeeId')?.enable({ emitEvent: false });
          searchCtrl.enable({ emitEvent: false });
          cloneCtrl.enable({ emitEvent: false });
        } finally {
          isClearing = false;
        }
      };

      const handleFieldChange = (control: any, otherControl: any) => {
        if (isClearing) return; // Skip if already clearing

        const has =
          control.value !== null &&
          control.value !== undefined &&
          ('' + control.value).toString().trim() !== '';
        const otherHas =
          otherControl.value !== null &&
          otherControl.value !== undefined &&
          ('' + otherControl.value).toString().trim() !== '';

        if (has) {
          otherControl.setValue('', { emitEvent: false });
          otherControl.disable({ emitEvent: false });
        } else {
          otherControl.enable({ emitEvent: false });
          if (!otherHas) {
            clearContractFields();
          }
        }
      };

      searchCtrl.valueChanges.subscribe((val) => {
        handleFieldChange(searchCtrl, cloneCtrl);
      });

      cloneCtrl.valueChanges.subscribe((val) => {
        handleFieldChange(cloneCtrl, searchCtrl);
      });
    }
  }

  onEntitySelect(val: any) {
    var temp: any = this.templates.filter((i) => i.entity === val);
    this.filteredTemplates = temp[0].template;
  }

  dateOfJoiningFilter = (m: Moment | null): boolean => {
    const day = (m || moment()).day();
    return day !== 0 && day !== 6;
  };

  empNameSelected(emp: any) {
    this.empName = emp;
  }

  overTimeSection(status: any) {
    console.log(status);
    this.showOverTimeSection = status;
  }

  custNameSelected(custId: any) {
    this.customerName = custId;
  }
  cloneContract() {
    var cloneContractId =
      this.newContractForm.controls['searchNishContractId'].value;
    this.getContractInfo(cloneContractId);
    this.newContractForm.controls['nishContractId'].setValue('');
  }

  searchContractId($event: Event) {
    this.successFlag = false;
    const contractID = this.newContractForm.controls['nishContractId'].value;
    this.getContractInfo(contractID);
  }
  getContractInfo(contractID) {
    if (contractID != '') {
      this.newcontractService.fetchContractInfo(contractID).subscribe((res) => {
        console.log(res);
        this.contract = res;
        this.newContractForm.patchValue({
          //nishContractId: this.contract.nishContractId,
          employeeId: this.contract.employeeId,
          contractId: this.contract.contractId,
          contractStatus: this.contract.contractStatus,
          clientName: this.contract.clientName,
          contractCompanyName: this.contract.contractCompanyName,
          subContractCompany1: this.contract.subContractCompany1,
          subContractCompany2: this.contract.subContractCompany2,
          subContractCompany3: this.contract.subContractCompany3,
          billingRate: this.contract.billingRate,
          contractStartDate: moment(
            this.contract.contractStartDate,
            'MM/DD/YYYY',
          ),
          contractEndDate: moment(this.contract.contractEndDate, 'MM/DD/YYYY'),
          comments: this.contract.comments,
          contractType: this.contract.contractType,
          perDayHrs: this.contract.perDayHrs,
          contractReference: this.contract.contractReference,
          vosReference: this.contract.vosReference,
          entity: this.contract.entity,
          template: this.contract.template,
          tsFlag: this.contract.tsFlag,
          invoicesDH: this.contract.invoicesDH,
          invoiceDueDate: this.contract.invoiceDueDate,
          billingDays: this.contract.billingDays,
          isOverTime: this.contract.isOverTime,
          contractOverTime: this.contract.contractOverTime,
        });
        this.filterEmpName = this.contract.employeeId;
        this.empName = this.contract.employeeId;
        this.filterCustomerName = this.contract.customerId;
        this.newContractForm.controls['employeeId'].disable();
        this.filterCustomerName = this.contract.customerId;
        this.customerName = this.contract.customerId;
        if (this.contract.isOverTime) {
          this.showOverTimeSection = true;
        }
      });
    }
  }

  onSubmit() {
    this.errorFlag = false;
    this.successFlag = false;

    if (this.customerName == '' || this.customerName == null) {
      this.errorFlag = true;
      this.errorDescription =
        'A Contract must be mapped to a Customer, please select a customer from dropdown';
      return;
    }

    if (this.empName == '' || this.empName == null) {
      this.errorFlag = true;
      this.errorDescription =
        'A Contract must be mapped to a NISH Employee, please select an employee from Search Employee field';
      return;
    }

    this.user = JSON.parse(localStorage.getItem('userDetails') || '{}') as User;
    console.log(this.newContractForm.value);
    this.newContractForm.patchValue({
      employeeId: this.empName,
      updatedBy: this.user.empId,
      customerId: this.customerName,
      contractStartDate: new Date(
        moment(this.newContractForm.value.contractStartDate)
          .utcOffset('+2000')
          .format('YYYY-MM-DD'),
      ),
      contractEndDate: new Date(
        moment(this.newContractForm.value.contractEndDate)
          .utcOffset('+2000')
          .format('YYYY-MM-DD'),
      ),
    });
    const body = JSON.stringify(this.newContractForm.getRawValue());

    console.log('leaves jason' + body);

    this.newcontractService.createContract(body).subscribe((data) => {
      console.log('data ==========> ' + data);

      if (data.errorCode == 'true') {
        this.errorFlag = true;
        this.errorDescription = data.errorDescription;
      } else {
        this.successFlag = true;
        this.nishContractId = data.nishContractId;
        this.newContractForm.reset();
      }
    });

    console.log('nishContractId...' + this.nishContractId);
  }
}

interface ContractResponse {
  nishContractId: number;
  errorCode: string;
  errorDescription: String;
}
